<template>
  <FormSelect
    :disabled="disabled"
    :loading="loading"
    :name="name"
    :options="zoneOptions"
    :required="required"
    :value="value"
    @input="$emit('input', $event)"
  />
</template>

<script>
import FormSelect from '@/components/Form/Select/index.vue'

import zonesApi from '@/api/zones'

export default {
  components: {
    FormSelect,
  },
  data: () => ({
    zoneOptions: [],
    loading: true,
  }),
  props: {
    name: { type: String, required: true },
    value: { type: String, default: null },
    disabled: { type: Boolean, default: false },
    required: { type: Boolean, default: false },
    siteUuid: { type: String },
  },
  watch: {
    siteUuid: {
      async handler() {
        if (this.siteUuid) {
          this.zoneOptions = await zonesApi.selectableZones(this.siteUuid)
          this.loading = false
        } else {
          this.$emit('input', null)
          this.zoneOptions = []
        }
      },
      immediate: true,
    },
  },
}
</script>
